import * as React from "react";
const SvgFireflies = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 56",
  width: "1em",
  height: "1em",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__a)",
  d: "M18.4 0H0v18.3h18.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__b)",
  d: "M40.2 22.1H21.8v18.3h18.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__c)",
  d: "M40.2 0H21.8v18.3H56v-2.6c0-4.2-1.7-8.1-4.6-11.1-3-2.9-7-4.6-11.2-4.6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__d)",
  d: "M0 22.1v18.3c0 4.2 1.7 8.1 4.6 11.1 3 2.9 7 4.6 11.2 4.6h2.6v-34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__e)",
  d: "m0 0 18.4 18.3H0z",
  opacity: 0.18
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__f)",
  d: "m21.8 22.1 18.4 18.3H21.8z",
  opacity: 0.18
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__g)",
  d: "M0 40.3c0 4.2 1.7 8.1 4.6 11.1 3 2.9 7 4.6 11.2 4.6h2.6V22.1z",
  opacity: 0.18
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Fireflies_svg__h)",
  d: "M40.2 0c4.2 0 8.2 1.7 11.2 4.6S56 11.5 56 15.7v2.6H21.8z",
  opacity: 0.18
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__a",
  x1: 144.664,
  x2: 54.381,
  y1: -133.778,
  y2: -38.919,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.113,
  stopColor: "#DE2D7A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#C5388F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#9B4AB0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.818,
  stopColor: "#6262DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3B73FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__b",
  x1: 145.166,
  x2: 54.883,
  y1: -133.308,
  y2: -38.45,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#FF3C82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.103,
  stopColor: "#F53E88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.274,
  stopColor: "#DC4598"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.492,
  stopColor: "#B251B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.745,
  stopColor: "#7961D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3B73FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__c",
  x1: 144.762,
  x2: 114.171,
  y1: -123.201,
  y2: -12.34,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.113,
  stopColor: "#DE2D7A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#C5388F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#9B4AB0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.818,
  stopColor: "#6262DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3B73FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__d",
  x1: 134.824,
  x2: 25.31,
  y1: -132.327,
  y2: -98.964,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.113,
  stopColor: "#DE2D7A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#C5388F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#9B4AB0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.818,
  stopColor: "#6262DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3B73FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__e",
  x1: 82.208,
  x2: 112.884,
  y1: -52.791,
  y2: -123.081,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.114,
  stopColor: "#DE286E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#C52361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.544,
  stopColor: "#9B1A4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.825,
  stopColor: "#620F30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3D081E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__f",
  x1: 107.654,
  x2: 138.33,
  y1: -78.53,
  y2: -148.819,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.114,
  stopColor: "#DE286E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#C52361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.544,
  stopColor: "#9B1A4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.825,
  stopColor: "#620F30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3D081E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__g",
  x1: 70.831,
  x2: 140.305,
  y1: -99.321,
  y2: -145.474,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.114,
  stopColor: "#DE286E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#C52361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.544,
  stopColor: "#9B1A4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.825,
  stopColor: "#620F30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3D081E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Fireflies_svg__h",
  x1: 297.69,
  x2: 309.595,
  y1: -1360.885,
  y2: -1454.875,
  gradientTransform: "matrix(.8571 0 0 -.8571 -79.239 -68.174)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E82A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.114,
  stopColor: "#DE286E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#C52361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.544,
  stopColor: "#9B1A4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.825,
  stopColor: "#620F30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#3D081E"
}))));
export default SvgFireflies;
//# sourceMappingURL=Fireflies.js.map